<template>
   <div class="page page-projectDetail">
     <div class="page-projectDetail-left">
          <el-menu :default-active="i" class="el-menu-vertical-demo" text-color="#000"
      active-text-color="#01A3FF" >
              <el-menu-item index="5" @click="$router.push('/projectAreaDetail' + projectID)">
                  <span slot="title"><i class="el-icon-date"></i>Dashboard</span>
             </el-menu-item>
             <el-menu-item index="1" @click="moveTo('/areaList')">
                  <span slot="title"><i class="el-icon-menu"></i>{{$store.state.module1.isChina?'场所管理':'Place manage'}}</span>
             </el-menu-item>
             <el-menu-item index="2" @click="$router.push('/devData0')">
                  <span slot="title"><i class="el-icon-printer"></i>{{$store.state.module1.isChina?'设备列表':'Device list'}}</span>
             </el-menu-item>
             <el-menu-item v-show="isAir" index="6" @click="$router.push('/airDev')">
              <span slot="title"><i class="el-icon-orange"></i>{{$store.state.module1.isChina?'新风管理':'Fresh air'}}</span>
            </el-menu-item>
             <el-menu-item index="3" @click="$router.push('/devLog')">
                  <span slot="title"><i class="el-icon-document"></i>{{$store.state.module1.isChina?'查看数据':'View data'}}</span>
             </el-menu-item>
             <el-menu-item index="4" @click="$router.push('/aimProject' + projectID)" v-show="false">
                  <span slot="title"><i class="iconfont icon-mubiaoguanli1"></i>{{$store.state.module1.isChina?'目标管理':'Management'}}</span>
             </el-menu-item>
             <!-- 权限管理
             <el-submenu index="4">
                <template slot="title">
                  <span slot="title"><i class="el-icon-edit-outline"></i>权限管理</span>
                </template>
                <el-menu-item index="4-1" @click="$router.push('/authManage')">权限管理</el-menu-item>
             </el-submenu>
             -->
          </el-menu>
     </div>
     <div class="page-projectDetail-right">
       <router-view></router-view>
     </div>
   </div>
</template>

<script>
import { Mixin } from '../../mixins/index.js'
export default {
  name: 'projectDetail',
  mixins: [Mixin],
  data () {
    return {
      areaList: null,
      i: '5-1',
      ProId: 1
    }
  },
  watch: {
    $route () {
      this.Index()
    }
  },
  methods: {
    Index () {
      var path = this.$route.path
      var p = path.slice(0, 5)
      switch (p) {
        case '/proj':
          this.i = '5'
          break
        case '/area':
          this.i = '1'
          break
        case '/devD':
          this.i = '2'
          break
        case '/devL':
          this.i = '3'
          break
        case '/aimP':
          this.i = '4'
          break
        case '/airD':
          this.i = '6'
          break
      }
    },
    moveTo (str) {
      this.$router.push(str + window.localStorage.getItem('proId'))
    }
  },
  created () {
    this.$nextTick(() => {
      this.Index()
      this.$store.commit('setProjectName', localStorage.getItem('proId'))
    })
    this.ProId = window.localStorage.getItem('proId')
  }
}
</script>

<style scoped lang='less'>
.page-projectDetail{
    display:flex;
    alig-items:flex-start;
}

.page-projectDetail-left{
    flex:0 0 2.48rem;
    height:100%;
    background:white;
}
.el-menu{
    height:100%;
    text-align:center;
}
.is-active{
   span{
    font-size:0.14rem;
    padding:0.12rem 0.4rem 0.12rem 0.1rem;
    background:#01A3FF;
    color:white;
    border-radius:0.12rem;
   }
   i{
     color:white;
   }
}
.isActive{
  font-size:0.14rem;
    padding:0.12rem 0.3rem 0.12rem 0.3rem;
    background:#01A3FF;
    color:white;
    border-radius:0.12rem;
}
.page-projectDetail-right{
  height:100%;
  flex:1;
  padding:0.1rem;
  overflow: scroll;
}
.el-menu-vertical-demo li span{
  font-weight:600;
  font-size:0.16rem;
}
.el-menu-vertical-demo li ul li{
    font-weight:600;
  font-size:0.14rem;
}
.el-submenu .el-menu-item{
  min-width:2rem;
}
</style>
